(function () {
  'use strict';

  const SELECTORS = {
    // Kaching
    selectedBundle: '.kaching-bundles__bar--selected',
    bundlePrice: '.kaching-bundles__bar-price',
    bundleComparePrice: '.kaching-bundles__bar-full-price',

    // Loop
    loopPurchaseOption: '.loop-widget-purchase-option',
    loopSelectedOption: '.loop-widget-purchase-option-selected',
    loopPrice: '.loop-widget-purchase-option-price',
    loopComparePrice: '.loop-widget-purchase-option-compare-at-price',

    // Loop subscription option
    subscriptionOption: '[data-loop-widget-selling-plan-group]'
  };

  let updateTimer = null;


  function getSelectedKachingPrices() {
    const selectedBundle = document.querySelector(
      SELECTORS.selectedBundle
    );

    if (!selectedBundle) {
      return null;
    }

    const price = selectedBundle
      .querySelector(SELECTORS.bundlePrice)
      ?.textContent
      .trim();

    const comparePrice = selectedBundle
      .querySelector(SELECTORS.bundleComparePrice)
      ?.textContent
      .trim();

    if (!price) {
      return null;
    }

    return {
      price,
      comparePrice
    };
  }

  function updateLoopPrices() {
    const prices = getSelectedKachingPrices();

    if (!prices) {
      return;
    }

    const loopOptions = document.querySelectorAll(
      SELECTORS.loopPurchaseOption
    );

    if (!loopOptions.length) {
      return;
    }

    loopOptions.forEach((option) => {
      const priceElement = option.querySelector(
        SELECTORS.loopPrice
      );

      const comparePriceElement = option.querySelector(
        SELECTORS.loopComparePrice
      );

      const isSelected = option.classList.contains(
        'loop-widget-purchase-option-selected'
      );

      if (!isSelected) {
        if (priceElement) {
          priceElement.style.visibility = 'hidden';
        }

        if (comparePriceElement) {
          comparePriceElement.style.visibility = 'hidden';
        }

        return;
      }

      if (priceElement) {
        priceElement.style.visibility = 'visible';

        if (priceElement.textContent.trim() !== prices.price) {
          priceElement.textContent = prices.price;
        }
      }

      if (comparePriceElement) {
        if (prices.comparePrice) {
          comparePriceElement.style.visibility = 'visible';

          if (
            comparePriceElement.textContent.trim() !==
            prices.comparePrice
          ) {
            comparePriceElement.textContent = prices.comparePrice;
          }
        } else {
          comparePriceElement.style.visibility = 'hidden';
        }
      }
    });
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(() => {
      updateLoopPrices();

      // Extra checks after app rendering
      setTimeout(updateLoopPrices, 100);
      setTimeout(updateLoopPrices, 300);
      setTimeout(updateLoopPrices, 600);
    }, 50);
  }


  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    for (const mutation of mutations) {
      if (
        mutation.type === 'childList' ||
        mutation.type === 'characterData' ||
        mutation.type === 'attributes'
      ) {
        shouldUpdate = true;
        break;
      }
    }

    if (shouldUpdate) {
      scheduleUpdate();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: [
      'class',
      'value',
      'aria-checked'
    ]
  });
  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        '.kaching-bundles__bar-variant-select, .kaching-bundles-option'
      )
    ) {
      scheduleUpdate();
    }
  });

  /**
   * Initial update
   */
  scheduleUpdate();

})();